import { render, staticRenderFns } from "./team-inbox-alert-search.vue?vue&type=template&id=a8324f9e&scoped=true"
import script from "./team-inbox-alert-search.vue?vue&type=script&lang=js"
export * from "./team-inbox-alert-search.vue?vue&type=script&lang=js"
import style0 from "./team-inbox-alert-search.vue?vue&type=style&index=0&id=a8324f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8324f9e",
  null
  
)

export default component.exports